import eventBus from '@/helpers/event-bus';
import { startNotification } from '@/notifications';

/*
 * يشغّل إشعارات FCM:
 * 1. يطلب صلاحية الإشعارات ويجلب توكن الجهاز (يُخزَّن في localStorage داخل startNotification).
 * 2. يرسل التوكن إلى الباك-إند عبر registerDeviceToken.
 * 3. يعرض إشعارات foreground ويبثّ 'FCM-message' على eventBus لبقية التطبيق.
 */
function startNotificationsFunctionality ({ router }) {
	return startNotification(
		{ router },
		(payload) => { eventBus.$emit('FCM-message', payload); }
	).then((token) => {
		if (token) {
			console.log('FCM device token:', token); // TEMP: للاختبار فقط — احذفه لاحقاً
			registerDeviceToken(token);
		}
		return token;
	}).catch((e) => {
		console.error('Notifications error:', e);
	});
}

// TODO: أرسل توكن الجهاز إلى الباك-إند (استبدل بنقطة الـ API الصحيحة بعد تأكيدها من فريق الباك-إند)
function registerDeviceToken (token) {
	// مثال:
	// return window.axios.put('/users/deviceToken', { fcmToken: token }, { preventRouteAbort: true });
}

export default function initNotifications ({ store, router }) {
	if (!('serviceWorker' in navigator) || !('Notification' in window)) return;

	// التنقّل عند الضغط على إشعار وصل في الخلفية (يرسله firebase-messaging-sw.js)
	navigator.serviceWorker.addEventListener('message', (event) => {
		if (event.data && event.data.type === 'WORKER_NAVIGATE') {
			router.push(event.data.redirectUrl).catch(() => {});
		}
	});

	// ابدأ فوراً إذا كان المستخدم مسجّلاً بالفعل عند فتح التطبيق
	if (store.state.auth.authenticated) {
		startNotificationsFunctionality({ router });
	}

	// ابدأ عند تسجيل الدخول لاحقاً (دون إعادة تحميل الصفحة)
	store.watch(
		(state) => state.auth.authenticated,
		(isAuthenticated) => {
			if (isAuthenticated) { startNotificationsFunctionality({ router }); }
		}
	);
}
